import { DataService } from "../service";
import { ApiService } from "../libs";

export class StandardService {
	// 一级标准目录
	static async GetStandardList() {
		return await DataService.get(`${ApiService.StdApi}/Standard/GetStandardList`, {}, { interceResponse: true });
	}

	// 二级子目录
	static async GetSubStandardList(params: { tb: string; q: string; pid: number }) {
		return await DataService.get(`${ApiService.StdApi}/Standard/GetSubStandardList`, params, { interceResponse: true });
	}

	// 推荐词查询产品
	static async GetStandardView(params: { src: string }) {
		return await DataService.get(`${ApiService.StdApi}/Standard/GetStandardView`, params, { interceResponse: true });
	}

	// 推荐词查询产品
	static async GetPath(path: string, params = {}) {
		return await DataService.get(`${ApiService.StdApi}/std/${path}`, {}, { interceResponse: true, responseType: "blob", ...params });
	}

	// ======================
	// ====== 需求相关 ======
	// ======================
	/**
	 * 发布需求
	 * @param content 
	 * @returns 
	 */
	static async AddDemand(content = '') {
		const fd = new FormData();
    fd.append('content', content);
		return await DataService.post(`${ApiService.StdApi}/Standard/AddDemand`, fd, {
			interceResponse: true,
			headers: {
				"Content-Type": "multipart/form-data",
			},
		})
	}

	/**
	 * 获取需求列表
	 * @param page 
	 * @param pageSize 
	 * @returns 
	 */
	static async GetDemands(page = 1, pageSize = 10) {
		return await DataService.get(`${ApiService.StdApi}/Standard/GetDemands?page=${page}&pageSize=${pageSize}`, {}, { interceResponse: true });
	}

	/**
	 * 提供需求资料
	 * @param demandId 
	 * @param file 
	 * @param name 
	 * @returns 
	 */
	static async AddDemandResource(demandId: string, file: any, name: string) {
		const fd = new FormData();
		fd.append('demandId', demandId);
		fd.append('file', file);
		fd.append('name', name);
		return await DataService.post(`${ApiService.StdApi}/Standard/AddDemandResource`, fd, {
			"Content-Type": "multipart/form-data"
		})
	}

	/**
	 * 获取需求资料列表
	 * @param page 
	 * @param pageSize 
	 * @returns 
	 */
	static async GetDemandResources(page = 1, pageSize = 10) {
		return await DataService.get(`${ApiService.StdApi}/Standard/GetDemandResources?page=${page}&pageSize=${pageSize}`, {}, { interceResponse: true });
	}
}
